import Vue from 'vue'
import { DateTime } from 'luxon'

Vue.prototype.$luxon = DateTime
